import Resolution from "engine/Resolution.js";
import {setSelectedPianoRollSteps} from 'actions/index.js';

const RESOLUTION = new Resolution(32, false);

export const expand = (track, steps, stepNumbers, amount, exponent) => {
    let firstStepNumber = getFirstStepNumber(stepNumbers);

    let copiedSteps = steps.map(x => x.getCopy(true, false));

    // for each step calculate the distance between the
    // step number & the first step number.

    // calculate new location by multiplying by amount
    // firs delette steps
    let pattern = track.getEasyPattern();
    pattern.deleteSteps(steps);

    let newSteps = [];
    let i=0;

    for (let [stepData, stepNumber] of stepNumbers) {
        let distance = stepNumber - firstStepNumber;
        let newStepNumber =
            firstStepNumber + Math.pow(distance * amount, exponent);
        let position = newStepNumber - Math.floor(newStepNumber);
        pattern.addStep(
            copiedSteps[i],
            Math.floor(newStepNumber),
            RESOLUTION,
            position);
        newSteps.push(
            copiedSteps[i]);
        
        i++;
    }
        
    track.updateSteps(true);

    track.sequencerEngine.dispatch(
        setSelectedPianoRollSteps(newSteps));
    return newSteps;
};

const getFirstStepNumber = (stepNumbers) => {
    let minStepData ;
    let minStepNumber=Infinity;
    for (let [stepData, stepNumber] of stepNumbers) {
        if (minStepNumber > stepNumber) {
            minStepNumber = stepNumber;
            minStepData = stepData;
        }
    }
    return minStepNumber;
};
